<template>
  <div id="videos">
    <div class="title section-title">
      <i class="anyteachicon anyteach-bofang1" />视频
    </div>
    <div class="preview">
      <div v-for="item in newVideos" :key="item.video_id" class="preview__item" @click="play(item)">
        <div>
          <div v-lazy:background-image="item.img" class="preview__bgd">
            <div
              v-if="current !== null && current.video_id === item.video_id"
              class="preview__overlay animated fadeIn"
            >
              <i class="anyteachicon anyteach-zhengzaibofang" />
            </div>
            <i
              class="preview__current animated fadeIn"
              v-if="current !== null && current.video_id === item.video_id"
            />
          </div>
          <div class="preview__text">
            <h1>{{ item.title }}</h1>
          </div>
        </div>
      </div>
    </div>
    <Modal
      v-if="showContent"
      :showComplete="true"
      :showClose="false"
      :tapToDismiss="true"
      :fullWidth="true"
      v-on:complete="closeModal"
      v-on:dismiss="closeModal"
      btnPrimary="关闭"
    >
      <div v-if="current" class="video" ref="video">
        <video :id="'TCPlayer' + nonce" :src="current.url" playsinline webkit-playsinline></video>
        <div class="desc">
          <h1 v-if="current.title">{{ current.title }}</h1>
          <h2 v-if="current.subtitle">{{ current.subtitle }}</h2>
          <p v-if="current.content">{{ current.content }}</p>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>

import Modal from "@/components/popup/Modal"
export default {
  name: "Videos",
  props: {
    videoType: {
      type: String,
      default: "10"
    },
    videos: {
      type: Array,
      default: function () {
        return []
      }
    },
  },
  components: {
    Modal,
  },
  data() {
    return {
      vod: [],
      nonce: parseInt(Math.random() * 1000000),
      current: null,
      TCPlayer: null,
      appID: "1257393913",
      showContent: false,
      articleContent: "",
      articleTitle: "",
    }
  },
  mounted() {
  },
  beforeDestroy() {
    this.TCPlayer = null
  },
  computed: {
    "newVideos": function () {
      let newVideos = []
      let nowVideos = this.videos
      for (let i = 0; i < nowVideos.length; i++) {
        const element = nowVideos[i]
        if (element.video_id) {
          newVideos.push(element)
        }
      }
      return newVideos
    }
  },
  methods: {
    closeModal() {
      this.showContent = false
      this.current = null
      this.TCPlayer = null
    },
    play(item) {
      this.showContent = true
      this.nonce = parseInt(Math.random() * 1000000)
      if (this.current && this.current.video_id === item.video_id) {
        return
      }
      this.current = item
      if (!this.TCPlayer) {
        this.$nextTick(() => {
          let width = 1
          let height = document.body.clientWidth * width * 9 / 16
          this.TCPlayer = TCPlayer("TCPlayer" + this.nonce, {
            fileID: item.video_id,
            appID: this.appID,
            width,
            height,
            controlBar: {
              playbackRateMenuButton: false,
              volumePanel: false,
              QualitySwitcherMenuButton: false,
            },
          })
        })
      } else {
        this.$nextTick(() => {
          this.TCPlayer.loadVideoByID({
            fileID: item.video_id,
            appID: this.appID,
          })
          this.TCPlayer.on("canplay", () => {
            this.TCPlayer.play()
          })
        })
      }
    },
  },
}
</script>
<style>
@import "https://imgcache.qq.com/open/qcloud/video/tcplayer/tcplayer.css";
</style>

<style lang="scss">
#videos {
  i {
    font-size: inherit;
  }
  .video-js {
    width: 100%;
    button {
      &:hover,
      &:active {
        background: none;
      }
    }
  }
  .vjs-control-bar {
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
    font-size: 0.6rem;
  }
  .vjs-current-time-display,
  .vjs-duration-display {
    @include avenir();
    font-size: 0.8rem;
  }

  .tcp-quality-switcher-value * {
    color: white;
    font-weight: 500;
    font-size: 0.9rem;
  }

  .vjs-poster {
  }
  .vjs-menu-content {
    bottom: 10px;
    * {
      font-size: 0.9rem;
      font-weight: 500;
    }
  }

  @media only screen and (min-width: 600px) {
    .video-js {
      max-height: 500px;
    }
  }
}
</style>
<style lang="scss" scoped>
@import "@/../static/css/carousel.scss";
@import "@/assets/css/promo.scss";
@import "../style.scss";

#videos {
  width: 100%;
  padding: 15px 0;
  border-bottom: 1px solid #eee;
  .title {
    padding: 0 5%;
  }

  .video {
    width: 100%;
    position: relative;
    margin-top: -15px;

    video {
      position: relative;
    }
    .desc {
      padding: 10px 15px;

      h1 {
        @include avenir-demi();
        font-size: 1.2rem;
        margin: 0;
        line-height: 1.3;
      }
      h2 {
        font-size: 0.8125rem;
        font-weight: 400;
        padding-bottom: 5px;
      }
      p {
        margin-top: 10px;
        color: $black;
      }
    }
    .video__overlay {
      position: absolute;
      background: linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0));
      width: 100%;
      left: 0;
      top: 0;
      padding: 0.5rem 10px 30px 10px;
      * {
        color: white;
      }
      h1 {
        @include avenir();
        font-size: 1rem;
        font-weight: 500;
        margin: 0;
        line-height: 1.3;
      }
      h2 {
        font-size: 0.8125rem;
        font-weight: 400;
      }
    }
  }

  .preview {
    $preview__width: 120px;
    $preview__height: 75px;
    width: 100%;
    overflow: auto;
    margin: 15px 0 0 0;
    white-space: nowrap;
    .animated {
      animation-duration: 0.1s !important;
    }
    .preview__bgd {
      width: $preview__width;
      height: $preview__height;
      border-radius: 3px;
      box-shadow: 0 0 25px 0 #efefef;
      background: $black;
      position: relative;
      margin: 0 0 10px 0;
      background-color: #eee;
      background-size: cover;
      background-position: center center;
    }
    .preview__current {
      border: 2px solid $blue;
      display: block;
      position: absolute;
      border-radius: 3px;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
    .preview__item {
      width: $preview__width;
      box-sizing: content-box;
      display: inline-block;
      margin-right: 15px;
      vertical-align: top;
      transition: all 0.1s;
      &:active {
        opacity: 0.6;
      }

      &:first-of-type {
        margin-left: 5%;
      }
      &:last-of-type {
        margin-right: 5%;
      }

      .preview__text {
        white-space: initial;
        h1 {
          font-size: 0.8rem;
          line-height: 1.2;
          @include avenir();
          text-overflow: ellipsis;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
    .preview__overlay {
      background-color: rgba(0, 0, 0, 0.7);
      width: 100%;
      height: 100%;
      position: absolute;
      border-radius: 3px;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      i {
        font-size: 1.5rem;
        color: white;
      }
    }
  }
  .video-container {
    width: 100%;
    white-space: nowrap;
    overflow: scroll;
    .video-wrapper {
      width: 100%;
      white-space: wrap;
      display: inline-block;
      position: relative;
      margin: 0 15px 0 0;
      h1 {
        @include avenir();
        font-size: 0.8125rem;
        font-weight: 500;
        top: 0;
        margin: 0;
        left: 0;
        color: white;
        position: absolute;
        background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
        width: 100%;
        padding: 0.5rem 10px 20px 10px;
        line-height: 1.4;
      }
    }
  }
}
// iPhone 4
@media screen and (max-width: 320px) {
}

// iPhone 5, 6
@media screen and (min-width: 321px) and (max-width: 414px) {
}

// Tablet
@media only screen and (min-width: 600px) {
  #videos .video video {
    height: 300px;
  }
}

// iPad landscape
@media only screen and (min-width: 1024px) {
}
</style>
